import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {ConfigurationService} from '../../../configuration/configuration.service';
import {Url} from '../../../../core/models/url';
import {AbstractAutocompletionService} from './abstract-autocompletion.service';
import {WkfCfgFieldService} from '../../../../core/redux/field/service/wkf/wkf-cfg-field.service';
import {TaskSearchResultService} from '../../../../core/redux/search-result/service/task-search-result.service';
import {Field} from '../../../../core/models/field';
import {Store} from '@ngrx/store';
import {selectWkfCfgFieldDatas} from '../../../../core/redux/field/field-selectors';

@Injectable({
  providedIn: 'root'
})
export class WkfSupervisionAutocompletionService extends AbstractAutocompletionService {

  wkfCfgFields$: Observable<{ [key: string]: Field }> = this.store.select(selectWkfCfgFieldDatas);

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    configAction: ConfigurationService,
    private taskSearchResultService: TaskSearchResultService,
    private wkfCfgFieldService: WkfCfgFieldService,
    private store: Store
  ) {
    super(http, translateService, configAction);
    this.apiAutocompleteByKeyword = Url.getWkfProtectedApiBaseUrl(this.configAction) + Url.SUPERVISION + Url.AUTOCOMPLETE_KEYWORD;
    this.apiAutocompleteByValue = Url.getWkfProtectedApiBaseUrl(this.configAction) + Url.SUPERVISION + Url.AUTOCOMPLETE_VALUE;
    this.apiAutocompleteByKeyValue = Url.getWkfProtectedApiBaseUrl(this.configAction) + Url.SUPERVISION + Url.AUTOCOMPLETE_KEY_VALUE;
    this.apiAutocompleteAggregateByKeyword = Url.getWkfProtectedApiBaseUrl(this.configAction) + Url.SUPERVISION + Url.AUTOCOMPLETE_AGGREGATE;
  }

  protected getApiBaseUrl(): string {
    return Url.getWkfProtectedApiBaseUrl(this.configAction);
  }

  protected getCfgFieldService(): WkfCfgFieldService {
    return this.wkfCfgFieldService;
  }

  protected getCurrentSearchResultService(/*entityType: string*/): TaskSearchResultService {
    return this.taskSearchResultService;
  }

  protected getCfgConfigStore(): Observable<{ [key: string]: Field }> {
    return this.wkfCfgFields$;
  }
}
